import { AnprVM } from 'shell/view-models/search-anpr';
import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { DateTime } from 'luxon';
import {
  transformToChoiceDate,
  formatoDataToChoice,
} from 'shell/components/shared/choice-date/functions';
import { CertificationFormVM } from 'civil-status/view-models/document-birth-form';
import { ResponseANPRANSC } from 'shell/models/ansc-person';
import { CODE_STATE_ITALIAN } from 'shell/constants/code-state-italian';
import { ID_ITALIAN_NATION } from 'shell/constants/id-italian-nation';

export const transformerPersonGeneralityList = (
  response: AxiosResponse<HttpResponse<ResponseANPRANSC>>
): AnprVM<CertificationFormVM> => {
  const risposta3002 = response.data.payload?.personaRisposta || {};
  const rispostaSoggetti = response.data.payload?.datiSoggettoCertificazioneList || [];

  if (rispostaSoggetti.length) {
    return {
      errors: [],
      warnings: [],
      persons: rispostaSoggetti.map((itemRispostaSoggetti) => {
        // controllo su entrmbi i codici, va tornato un solo codice o il nostro o quello di ANPR
        const isForeign =
          itemRispostaSoggetti.idStatoNascita !== CODE_STATE_ITALIAN &&
          itemRispostaSoggetti.idStatoNascita !== ID_ITALIAN_NATION?.toString();

        return {
          accountholder: {
            datiSoggettoCertificazione: itemRispostaSoggetti,
            idSubjectAnpr: itemRispostaSoggetti.idAnpr || '',
            idAnsc: itemRispostaSoggetti.idAnscSoggetto || '',
            matricola: itemRispostaSoggetti.matricola || '',
            fiscalCode: itemRispostaSoggetti.codiceFiscale || '',
            name: itemRispostaSoggetti.nome || '',
            surname: itemRispostaSoggetti.cognome || '',
            birthDate: itemRispostaSoggetti.dataNascita
              ? DateTime.fromISO(itemRispostaSoggetti.dataNascita)
              : null,
            birthChoiceDate: formatoDataToChoice(itemRispostaSoggetti.idFormatodata),
            age: itemRispostaSoggetti.anni || '',
            idTypeDate: itemRispostaSoggetti.idFormatodata || '',
            typeDate: itemRispostaSoggetti.formatodata || '',
            gender: itemRispostaSoggetti.sesso || '',
            isForeign,
            foreignState: isForeign
              ? {
                  id: itemRispostaSoggetti.idStatoNascita || '',
                  value: itemRispostaSoggetti.nomeStatoNascita || '',
                }
              : null,
            foreignMunicipality: isForeign
              ? {
                  id: itemRispostaSoggetti.idComuneNascita || '',
                  code: itemRispostaSoggetti.idComuneNascita || '',
                  description: itemRispostaSoggetti.descrizioneLocalitaEstera || '',
                  province: itemRispostaSoggetti.nomeProvinciaNascita || '',
                  idProvince: itemRispostaSoggetti.idProvinciaNascita || '',
                }
              : null,
            municipality:
              !isForeign && itemRispostaSoggetti.idComuneNascita
                ? {
                    id: itemRispostaSoggetti.idComuneNascita || '',
                    code: itemRispostaSoggetti.idComuneNascita || '',
                    description: itemRispostaSoggetti.nomeComuneNascita || '',
                    province: itemRispostaSoggetti.nomeProvinciaNascita || '',
                    idProvince: itemRispostaSoggetti.idProvinciaNascita || '',
                  }
                : null,
            // documentNumber: person.cartaIdentita?.numero || '',
            // documentIssuedDate: person.cartaIdentita?.dataRilascio
            //   ? DateTime.fromISO(person.cartaIdentita?.dataRilascio)
            //   : null,
            // isForeignDocument: !!person.cartaIdentita?.consolatoRilascio,
            // foreignStateDocument: person.cartaIdentita?.consolatoRilascio?.descrizioneConsolato,
            // municipalityDocument: person.cartaIdentita?.comuneRilascio
            //   ? {
            //       id: person.cartaIdentita?.comuneRilascio?.codiceIstat || '',
            //       description: person.cartaIdentita?.comuneRilascio?.nomeComune || '',
            //       province: person.cartaIdentita?.comuneRilascio?.siglaProvinciaIstat || '',
            //     }
            //   : null,
            // residenceString: residence,
            birthplace: itemRispostaSoggetti.nomeComuneNascita
              ? `${itemRispostaSoggetti.nomeComuneNascita} ${
                  itemRispostaSoggetti.nomeProvinciaNascita
                    ? `, (${itemRispostaSoggetti.nomeProvinciaNascita})`
                    : ''
                }`
              : itemRispostaSoggetti.descrizioneLocalitaEstera || '',
            // state,
            isANSC: response.data.payload.ansc,
          },
          copies: '1',
          hidden: {
            delete: true,
            edit: true,
          },
        } as CertificationFormVM;
      }) as Array<CertificationFormVM>,
    };
  }

  return {
    warnings: (risposta3002?.risposta3002OK?.listaAnomalie?.errore || []).map((warning) => ({
      id: warning.codiceErroreAnomalia,
      value: warning.testoErroreAnomalia,
    })),
    errors: (risposta3002?.rispostaKO?.listaErrori?.errore || []).map((error) => ({
      id: error.codiceErroreAnomalia,
      value: error.testoErroreAnomalia,
    })),
    persons: (risposta3002?.risposta3002OK?.listaSoggetti?.datiSoggetto || []).map((person) => {
      const birthChoiceDate = transformToChoiceDate(
        person.generalita?.senzaGiorno,
        person.generalita?.senzaGiornoMese
      );
      const residenceArray = person.residenza || [];

      let birthplace = '';
      // birthplace check for object
      if (person.generalita?.luogoNascita?.localita) {
        birthplace = `${person.generalita?.luogoNascita?.localita.descrizioneLocalita} (${person.generalita?.luogoNascita?.localita.descrizioneStato})`;
      }

      if (person.generalita?.luogoNascita?.comune) {
        birthplace = `${person.generalita?.luogoNascita?.comune.nomeComune} (${person.generalita?.luogoNascita?.comune.siglaProvinciaIstat})`;
      }
      // Residence check for object
      let residence = '';
      // scelgo il primo o è un array?
      if (residenceArray[0]?.indirizzo) {
        residence = `${residenceArray[0]?.indirizzo.comune?.nomeComune || ''} (${
          residenceArray[0]?.indirizzo.comune?.siglaProvinciaIstat || ''
        })`;
      }
      // scelgo il primo o è un array?
      if (residenceArray[0]?.localitaEstera) {
        residence = `${residenceArray[0]?.localitaEstera?.indirizzoEstero?.localita?.descrizioneLocalita} (${residenceArray[0]?.localitaEstera?.indirizzoEstero?.localita?.descrizioneStato})`;
      }

      let state = '';
      // state check for object
      if (residenceArray[0]?.indirizzo?.toponimo) {
        const toponym = residenceArray[0]?.indirizzo?.toponimo;

        const civic = residenceArray[0]?.indirizzo?.numeroCivico;

        state = `${toponym.specie} ${toponym.denominazioneToponimo},${civic?.numero}${
          civic?.esponente1 ? `/${civic.esponente1}${civic.lettera}` : ''
        }`;
      }

      if (person.generalita?.soggettoAIRE && person.generalita?.soggettoAIRE === 'S') {
        state = 'Iscritto AIRE';
      }

      if (person.datiCancellazione && person.datiCancellazione?.descrizioneMotivoCancellazione) {
        state = `${person.datiCancellazione.descrizioneMotivoCancellazione}`;
      }

      return {
        accountholder: {
          datiSoggetto: person,
          residenceString: residence,
          idSubjectAnpr: person.generalita?.idSchedaSoggettoANPR,
          idAnsc: person.idAnsc || '',
          matricola:
            person.codicePersonaSipo ||
            person.generalita?.idSchedaSoggettoComune?.idSchedaSoggetto ||
            '',
          fiscalCode: person.generalita?.codiceFiscale?.codFiscale || '',
          name: person.generalita?.nome || '',
          surname: person.generalita?.cognome || '',
          birthDate: person.generalita?.dataNascita
            ? DateTime.fromISO(person.generalita?.dataNascita)
            : null,
          withoutSurname: person.generalita?.senzaCognome === '1',
          withoutName: person.generalita?.senzaNome === '1',
          gender: person.generalita?.sesso || '',
          birthChoiceDate: birthChoiceDate,
          isForeign: Boolean(person.generalita?.luogoNascita?.localita),
          foreignState: person.generalita?.luogoNascita?.localita
            ? {
                id: person.generalita?.luogoNascita?.localita?.codiceStato || '',
                value: person.generalita?.luogoNascita?.localita?.descrizioneStato || '',
              }
            : null,
          foreignMunicipality: person.generalita?.luogoNascita?.localita
            ? {
                id: person.generalita?.luogoNascita?.localita?.codiceStato || '',
                description: person.generalita?.luogoNascita?.localita?.descrizioneLocalita || '',
                province: person.generalita?.luogoNascita?.localita?.provinciaContea || '',
              }
            : null,
          municipality: person.generalita?.luogoNascita?.comune
            ? {
                id: person.generalita?.luogoNascita?.comune?.codiceIstat || '',
                description: person.generalita?.luogoNascita?.comune?.nomeComune || '',
                province: person.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || '',
              }
            : null,
          documentNumber: person.cartaIdentita?.numero || '',
          documentIssuedDate: person.cartaIdentita?.dataRilascio
            ? DateTime.fromISO(person.cartaIdentita?.dataRilascio)
            : null,
          isForeignDocument: !!person.cartaIdentita?.consolatoRilascio,
          foreignStateDocument: person.cartaIdentita?.consolatoRilascio?.descrizioneConsolato,
          municipalityDocument: person.cartaIdentita?.comuneRilascio
            ? {
                id: person.cartaIdentita?.comuneRilascio?.codiceIstat || '',
                description: person.cartaIdentita?.comuneRilascio?.nomeComune || '',
                province: person.cartaIdentita?.comuneRilascio?.siglaProvinciaIstat || '',
              }
            : null,
          birthplace,
          state,
          isANSC: response.data.payload.ansc,
        },
        copies: '1',
        hidden: {
          delete: true,
          edit: true,
        },
      } as CertificationFormVM;
    }) as Array<CertificationFormVM>,
  };
};
